import { useRequest } from 'ahooks';
import { ITemplateCategoryView, ITemplateInfoView } from 'apis/models';
import {
  listUsingPOST,
  showCategoriesUsingPOST,
  useTemplateUsingPOST as applyTemplateUsingPOST,
} from 'apis/template-controller';
import { goEditor } from 'common/action';
import { _actionEnd, _actionStart, _tracker } from 'common/radar';
import BaseLayout from 'components/BaseLayout';
import { showPreview } from 'components/Dialog';
import { Card, List, message } from 'm-ui';
import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import Categoary from './component/Categoary';
import GcCard from './component/GcCard';
import './index.less';

const initialState: {
  categoryList: ITemplateCategoryView[];
  categoryId: number[];
  page: number;
  pageSize: number;
  total: number;
  list: ITemplateInfoView[];
} = {
  categoryList: [],
  categoryId: [],
  page: 1,
  pageSize: 10,
  total: 0,
  list: [],
};
const TemplateCenter = () => {
  const [state, setState] = useImmer(initialState);
  // 使用模板
  const onUse = async (record: ITemplateInfoView) => {
    try {
      const result = await applyTemplateUsingPOST({ templateId: record.templateId });
      message.success('使用模板成功');
      goEditor(result.data.id);
      _tracker('使用模板点击');
    } catch (error) {
      // console.error(error);
    }
  };
  // 预览
  const previewHandler = (record: ITemplateInfoView) => {
    showPreview(record, () => {
      onUse(record).then((res) => {
        _actionEnd('预览使用模板');
      });
    });
    _tracker('模板预览点击');
    _actionStart('预览使用模板');
  };
  const { run: fetchCategoryList } = useRequest(showCategoriesUsingPOST, {
    manual: true,
    onSuccess(res) {
      const list = (res.data || []).filter((item) => item && item.subCategory.length > 0);
      setState((draft) => {
        draft.categoryList = list;
        draft.categoryId = list.map((item) => item.subCategory[0].id || 0);
      });
    },
  });
  const { run: fetchTemplateList, loading } = useRequest(listUsingPOST, {
    manual: true,
    onSuccess(res, params) {
      setState((draft) => {
        draft.list = res.data.list;
        draft.pageSize = res.data.splitInfo.pageSize;
        draft.total = res.data.splitInfo.totalNum;
      });
    },
  });
  useEffect(() => {
    fetchCategoryList();
  }, [fetchCategoryList]);
  useEffect(() => {
    if (state.categoryId.length <= 0) return;
    const { list, total, categoryList, ...params } = state;
    fetchTemplateList({
      req: params,
    });
  }, [state.categoryId, state.page, state.pageSize]);
  return (
    <div className="page page-template-center">
      <BaseLayout width={1200}>
        <Card bordered={false}>
          <Categoary
            value={state.categoryId}
            list={state.categoryList}
            onChange={(list) => {
              setState((draft) => {
                draft.categoryId = list;
                draft.page = 1;
              });
            }}
          />
        </Card>
        <div style={{ marginTop: 16 }}>
          <List
            split={false}
            grid={{
              gutter: 16,
            }}
            loading={loading}
            pagination={{
              position: 'bottom',
              current: state.page,
              pageSize: state.pageSize,
              total: state.total,
              onChange: (page, pageSize) => {
                setState((draft) => {
                  draft.page = page;
                  draft.pageSize = pageSize ?? 10;
                });
              },
            }}
            bordered={false}
            dataSource={state.list}
            renderItem={(item) => (
              <List.Item>
                <GcCard
                  record={item}
                  onPreview={() => previewHandler(item)}
                  onUse={async () => onUse(item)}
                />
              </List.Item>
            )}
          />
        </div>
      </BaseLayout>
    </div>
  );
};

export default TemplateCenter;
